<template>
    <div class="lw-filters-wrapper" v-show="showFilters">
        <div class="learnworlds-button-wrapper with-flexible-parts lw-filters horizontal flex align-items-center lw-content-block learnworlds-element">

            <div class="learnworlds-main-text filter learnworlds-main-text-small filter"
                 v-for="option in filtersConfig"
                 v-if="shouldBeDisplayed('button',option) && option.translatedLabel"
                 :class="primaryFilterSelectedClass(option.filteringKey)"
                 @click="primaryFilterApplied(option.filteringKey)"
            >
                <span> {{option.translatedLabel }} </span>
            </div>

        </div>
    </div>
</template>

<script>
    import ComponentTemplatesMixin from "../../mixins/ComponentTemplatesMixin";

    export default {
        name: "BundleCardsFilters1",
        mixins: [ComponentTemplatesMixin],
        props: {
            filtersConfig : {
                type: Object,
            },
            disabledFilters: {
                type: Array,
            },
            selectedPrimaryFilter : {
                type:  String
            },
            selectedSecondaryFilter : {
                type:  String
            },
            showFilters: {
                type: Boolean
            }
        },
        methods: {
            primaryFilterSelectedClass (filterKey) {
                return this.selectedPrimaryFilter === filterKey ? 'border-bottom' : 'text-only';
            },
            primaryFilterApplied (primaryKey) {
                this.emitAction('primary-filter-applied',primaryKey);
            },
            secondaryFilterApplied (primaryKey,secondaryKey) {
                this.emitAction('secondary-filter-applied',{primaryKey,secondaryKey});
            },
            shouldBeDisplayed (type,option) {
                return option.filterAvailable && this.filterEnabled(option.filteringKey);
            },
            filterEnabled (filterKey) {
                return this.disabledFilters && !this.disabledFilters.includes(filterKey);
            },
        }
    }
</script>

